module.exports = __webpack_public_path__ + "img/Recycling.88871248.svg";